module.exports = __webpack_public_path__ + "static/ss3.8ab9011c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss/ss3.png
// module id = 1166
// module chunks = 112875127094159